module.exports = __webpack_public_path__ + "img/tournaments_900.b2d15d7c.png";